import { Check } from "lucide-react";

export function OptionCard({ selected, onClick, img, label, desc, swatch, dataTestid, multi }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={dataTestid}
      className={`group relative text-left rounded-xl border transition-all duration-200 overflow-hidden ${
        selected
          ? "border-[#D4AF37] shadow-[0_18px_50px_-24px_rgba(212,175,55,0.55)]"
          : "border-[#27272A] hover:border-[#AA8035]"
      } bg-[#0d0d0d]`}
    >
      {img && (
        <div className="aspect-[4/3] overflow-hidden bg-[#111]">
          <img
            src={img}
            alt={label}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
            loading="lazy"
          />
        </div>
      )}
      {swatch && !img && (
        <div className="aspect-[4/3] flex items-center justify-center">
          <span
            className="block w-24 h-24 rounded-full border border-[#27272A]"
            style={{ background: swatch }}
          />
        </div>
      )}
      <div className="p-4">
        <div className="flex items-start justify-between gap-3">
          <div className="font-display text-lg text-white leading-tight">{label}</div>
          <span
            className={`flex-none w-5 h-5 rounded-full border transition-colors ${
              selected
                ? "bg-[#D4AF37] border-[#D4AF37]"
                : "border-[#3f3f46] bg-transparent"
            } flex items-center justify-center`}
          >
            {selected && <Check className="w-3 h-3 text-black" />}
          </span>
        </div>
        {desc && <div className="text-xs text-[#A1A1AA] mt-1.5 leading-relaxed">{desc}</div>}
        {multi && !selected && (
          <div className="text-[10px] tracking-[0.2em] uppercase text-[#6b6b72] mt-2">Tap to add</div>
        )}
      </div>
    </button>
  );
}

export function CompactChip({ selected, onClick, label, swatch, dataTestid }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={dataTestid}
      className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border text-sm transition-colors ${
        selected
          ? "border-[#D4AF37] bg-[#D4AF37]/10 text-[#F3E5AB]"
          : "border-[#27272A] text-[#D1D1D6] hover:border-[#AA8035]"
      }`}
    >
      {swatch && (
        <span
          className="w-3.5 h-3.5 rounded-full border border-[#27272A]"
          style={{ background: swatch }}
        />
      )}
      {label}
    </button>
  );
}
